<smrts-dialog [title]="title" [hasFootnote]="true">

  <div class="content custom-table">

    <div class="custom-table-row">
      <div class="custom-table-col one-column-width">
        <p-floatlabel variant="on">
          <input pInputText fluid [ngModel]="contaAtual?.nome" readonly />
          <label>Conta que será mesclada</label>
        </p-floatlabel>
      </div>
      <div class="custom-table-col one-column-width">
        <app-generic-autocomplete [items]="contas" inputId="conta" displayField="nome" label="Mesclar na conta"
          [(ngModel)]="contaSelecionada" (selectionChange)="onSelectionChange()">
        </app-generic-autocomplete>
      </div>
    </div>

    <div class="custom-table-row">
      <div class="custom-table-col one-column-width">
        <p-floatlabel variant="on">
          <input pInputText fluid [(ngModel)]="nomeFinal" />
          <label>Nome final</label>
        </p-floatlabel>
      </div>
      <div class="custom-table-col one-column-width date-column">
        <p-floatlabel variant="on">
          <p-datepicker fluid [showIcon]="true" dateFormat="dd/mm/yy" appendTo="body" [(ngModel)]="dataLancamentoConciliado"
            [disabled]="naoExisteContaComBanco" />
          <label>Conciliar lançamentos até</label>
        </p-floatlabel>
        <i class="pi pi-info-circle info-icon" [pTooltip]="tooltipContent"></i>
      </div>
    </div>

  </div>

  <div footnote class="inline-element footnote">
    <button class="accent-text-button btn-cancelar" mat-button [mat-dialog-close]="false">
      Cancelar
    </button>
    <button class="white-text-button" mat-flat-button (click)="salvarClick()">
      Salvar
    </button>
  </div>
</smrts-dialog>